/* ============================================================
   VARNIYA — DIAMOND JOURNEY controller
   Vanilla JS, no dependencies. Supports multiple instances and
   the Shopify theme editor (re-inits on section load).
   ============================================================ */
(function () {
  'use strict';

  function parseJSON(el, fallback) {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function pushAnalytics(cfg, payload) {
    if (!cfg || !cfg.analytics) return;
    window.dataLayer = window.dataLayer || [];
    try { window.dataLayer.push(payload); } catch (e) {}
  }

  function init(root) {
    if (!root || root.__djInit) return;
    root.__djInit = true;
    root.classList.add('dj--js');

    var cfg = parseJSON(root.querySelector('[data-dj-config]'), { analytics: false, deepLink: true, conciergeUrl: '/pages/help' });
    var live = root.querySelector('[data-dj-live]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-dj-stage][role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-dj-panel]'));
    if (!tabs.length) return;

    function panelFor(slug) {
      return panels.filter(function (p) { return p.getAttribute('data-dj-panel') === slug; })[0];
    }

    function activate(slug, opts) {
      opts = opts || {};
      var found = false;
      tabs.forEach(function (tab) {
        var isMatch = tab.getAttribute('data-dj-stage') === slug;
        if (isMatch) found = true;
        tab.classList.toggle('is-active', isMatch);
        tab.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        tab.setAttribute('tabindex', isMatch ? '0' : '-1');
      });
      if (!found) return false;

      panels.forEach(function (p) {
        var isMatch = p.getAttribute('data-dj-panel') === slug;
        p.classList.toggle('is-active', isMatch);
        if (isMatch) { p.removeAttribute('hidden'); }
        else { p.setAttribute('hidden', ''); }
      });

      if (opts.focus) {
        var t = tabs.filter(function (x) { return x.getAttribute('data-dj-stage') === slug; })[0];
        if (t) t.focus();
      }
      if (opts.scrollIntoView) {
        var t2 = tabs.filter(function (x) { return x.getAttribute('data-dj-stage') === slug; })[0];
        if (t2 && t2.scrollIntoView) { try { t2.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (e) {} }
      }

      var titleEl = panelFor(slug) && panelFor(slug).querySelector('.dj__panel-tag, .dj__panel-eyebrow');
      if (live && titleEl) live.textContent = 'Showing: ' + (titleEl.textContent || slug).replace(/[“”"]/g, '').trim();

      if (!opts.silent) {
        pushAnalytics(cfg, { event: 'journey_stage_selected', journey_stage: slug });
        if (cfg.deepLink && opts.updateHash !== false) {
          try { history.replaceState(null, '', '#stage/' + slug); } catch (e) {}
        }
      }
      return true;
    }

    /* --- rail: click + roving keyboard --- */
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-dj-stage'), { scrollIntoView: true });
      });
      tab.addEventListener('keydown', function (e) {
        var idx = i, next = null;
        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown': next = (idx + 1) % tabs.length; break;
          case 'ArrowLeft':
          case 'ArrowUp': next = (idx - 1 + tabs.length) % tabs.length; break;
          case 'Home': next = 0; break;
          case 'End': next = tabs.length - 1; break;
          default: return;
        }
        e.preventDefault();
        activate(tabs[next].getAttribute('data-dj-stage'), { focus: true, scrollIntoView: true });
      });
    });

    /* --- view-all toggle --- */
    root.querySelectorAll('[data-dj-viewall]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('aria-controls');
        var list = id ? root.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id)) : btn.parentNode.querySelector('[data-dj-all]');
        if (!list) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) { list.setAttribute('hidden', ''); }
        else {
          list.removeAttribute('hidden');
          var stage = list.closest('[data-dj-panel]');
          pushAnalytics(cfg, { event: 'journey_view_all', journey_stage: stage ? stage.getAttribute('data-dj-panel') : null });
        }
      });
    });

    /* --- outbound analytics (questions, products, collections, ctas) --- */
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-dj-q]');
      if (q) { pushAnalytics(cfg, { event: 'journey_question_clicked', question_slug: q.getAttribute('data-dj-q'), journey_stage: q.getAttribute('data-dj-stage') }); return; }
      var p = e.target.closest('[data-dj-product]');
      if (p) { pushAnalytics(cfg, { event: 'journey_product_clicked', product: p.getAttribute('data-dj-product'), journey_stage: p.getAttribute('data-dj-stage') }); return; }
      var c = e.target.closest('[data-dj-collection]');
      if (c) { pushAnalytics(cfg, { event: 'journey_collection_clicked', collection: c.getAttribute('data-dj-collection'), journey_stage: c.getAttribute('data-dj-stage') }); return; }
      var cta = e.target.closest('[data-dj-cta]');
      if (cta) { pushAnalytics(cfg, { event: 'journey_cta_clicked', cta: cta.getAttribute('data-dj-cta'), journey_stage: cta.getAttribute('data-dj-stage') }); return; }
    });

    /* --- deep link on load --- */
    function openFromHash(silent) {
      if (!cfg.deepLink) return false;
      var m = (location.hash || '').match(/^#stage\/([a-z0-9\-]+)/i);
      if (m) return activate(m[1], { silent: silent, scrollIntoView: true });
      return false;
    }
    if (!openFromHash(true)) {
      var first = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || tabs[0];
      activate(first.getAttribute('data-dj-stage'), { silent: true, updateHash: false });
    }
    window.addEventListener('hashchange', function () { openFromHash(false); });
  }

  function boot() {
    document.querySelectorAll('[data-dj-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Shopify theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-dj-root]');
    if (root) { root.__djInit = false; init(root); }
  });
})();
